// Here is where you put all feature flags
// You might not need to use these constants, especially if your code is in TS
export const OPTIMIZELY_FEATURE_EXAMPLE_FEATURE = 'example_feature';
export const OPTIMIZELY_MULTIPLE_PUBLIC_CLASSES = 'multiple_public_classes';
export const OPTIMIZELY_INSTITUTION_USER_INFO = 'institution_user_info';
export const OPTIMIZELY_SIGNUP_TO_ANY_PRICING_PLAN =
  'signup_to_any_pricing_plan';
export const OPTIMIZELY_INSTITUTION_EXPLICIT_USER_INFO =
  'institution_explicit_user_info';
export const OPTIMIZELY_ACCREDIBLE_INTEGRATION = 'accredible_integration';
export const OPTIMIZELY_GLOBAL_CUSTOM_PLANS = 'global_custom_plans';
export const OPTIMIZELY_REVENUE_SHARE_SETUP = 'revenue_share_setup';
export const OPTIMIZELY_STRIPE_CONNECT_MARKETPLACE =
  'stripe_connect_marketplace';
export const OPTIMIZELY_STRIPE_CONNECT_SETUP = 'stripe_connect_setup';
